import { createContext } from 'react';

export const setSizeContext = createContext(() => {});
